var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.549,
    height: 42.332,
    viewBox: "0 0 40.549 42.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2674",
    "data-name": "Rectangle 2674",
    width: 40.549,
    height: 42.332,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 12.9,
    cy: 12.9,
    r: 12.9,
    transform: "translate(7.375 8.266)",
    fill: "none",
    stroke: "#344154",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M39.022,14.7l.809-.84L36.378,7.882l-1.133.28a9.162,9.162,0,0,1-6.81-1.02l-.07-.04a9.211,9.211,0,0,1-4.314-5.4L23.728.579H16.821L16.5,1.7a9.188,9.188,0,0,1-4.3,5.4l-.03.018-.031.018A9.2,9.2,0,0,1,5.306,8.163L4.172,7.882.719,13.864l.808.839A9.207,9.207,0,0,1,4.049,21.14v.082a9.164,9.164,0,0,1-2.521,6.407l-.809.841,3.453,5.981,1.132-.28a9.16,9.16,0,0,1,6.81,1.02l.071.04a9.209,9.209,0,0,1,4.313,5.4l.323,1.12h6.907l.324-1.122a9.2,9.2,0,0,1,4.3-5.4l.031-.018.031-.017a9.192,9.192,0,0,1,6.826-1.03l1.134.281,3.453-5.981-.809-.84A9.21,9.21,0,0,1,36.5,21.193c0-.027,0-.055,0-.081A9.172,9.172,0,0,1,39.022,14.7Z",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M18.006,23.029l2.145,1.913,3.093-3.783",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2673",
    "data-name": "Rectangle 2673",
    width: 11.286,
    height: 7.977,
    transform: "translate(14.685 19.124)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M24.719,17.646a4.392,4.392,0,1,0-8.783,0",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec);
export default __webpack_public_path__ + "static/media/sec.e1d6fa5d95f33812a317f2aeef5dce7e.svg";
export { ForwardRef as ReactComponent };